
    import Index from   "./_Index.vue"  
    import { Options, Vue } from "vue-class-component";   
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "DisciplinaInstrutor",
        components: { Index },  
    }) 
    export default class DisciplinaInstrutor extends Vue { 

        @authStore.Getter
		public perfis!: any  

        public modal_cadastro ;
        
        created(){ 
            this.modal_cadastro = 'kt_cadatrar_disciplina_instrutor';
		}  
    }
